"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMemoizedSelector = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var memoize_1 = tslib_1.__importDefault(require("lodash/memoize"));
var json_stable_stringify_1 = tslib_1.__importDefault(require("json-stable-stringify"));
/**
 * Memoizes selector factory by its arguments.
 * This avoids recreating & recomputing selector on each render (and thus changing reference of the result), if the factory arguments are the same.
 * Use it wisely (don't use it for selector factories that changes arguments very often, or selector factories that are used in a large component lists/trees).
 *
 * Another option is to use this approach: https://react-redux.js.org/api/hooks#using-memoizing-selectors but it's ugly.
 *
 * @param selector - selector factory
 * @returns selector factory that will be memoized by its stringified arguments
 */
exports.createMemoizedSelector = function (selector) { return memoize_1.default(selector, function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return json_stable_stringify_1.default(args, { space: 0 });
}); };
//# sourceMappingURL=selectors.js.map